const AlertPermissions = {
  // View
  VIEW_ALERT_TAB: 'alerts_tab__read',
  VIEW_ALERT_CAMERA_STREAMS: 'cameras_streams__view',
  VIEW_ALERT_DASHBOARD: 'alerts_dashboard__read',
  VIEW_ALERT_SUMMARY: 'alerts_summary__read',
  VIEW_ALERT_CONFIGURATION: 'alerts_config__read',
  VIEW_ALERT_CONFIG: 'alerts_configuration__config__read',
  VIEW_ALERT_INVALID_ALERT: 'alerts__invalid_alert__read',
  ALERT_SUMMARY_ASSIGNEE_READ: 'alert_assignee_read',
  AL_SUMMARY_VIEW_RAW_IMAGE: 'alerts_summary__raw_image__read',
  READ_ALERT_STATUS: 'alert_status_read',
  READ_ALERT_MARKED_FOR_DELETION: 'alert_marked_for_deletion_read',

  // Write
  DOWNLOAD_ALERT_REPORT: 'alerts__report__download',
  COMMENT_ALERT_SUMMARY: 'alerts__comment__write',
  DRAW_ALERT_SUMMARY: 'alerts_summary__annotations__update',
  CONFIGURE_ALERT: 'alerts_configuration__configure',
  CALIBRATE_ALERT: 'alerts_configuration__calibrate',
  CONFIGURE_MANUAL_USE_CASES: 'alerts_configuration__manual_configure',
  CONFIGURE_NON_MANUAL_USE_CASES: 'alerts_configuration__automatic_configure',
  ALERT_TRANSFER: 'alerts__transfer',
  DOWNLOAD_ALERT_PREVIEW: 'alerts__preview__download',
  AL_SUMMARY_ASSIGNEE_WRITE: 'alert_assignee_write',
  WRITE_ALERT_STATUS: 'alert_status_write',

  // UPDATE

  // DELETE
  DELETE_ALERTS: 'alerts__delete',

  // ACTIONS
  WRITE_COMMENT_REPORT: 'alerts__report__write_comment',
  AL_ROI_WRITE: 'camera_roi_write',
};

export default AlertPermissions;
